module.exports = __webpack_public_path__ + "static/media/youtube.07935241.svg";